import React from 'react';
import styled from 'styled-components';
import { FiArrowLeft } from 'react-icons/fi';
import MappingCheckPanel from './MappingCheckPanel.jsx';
import ReviewIssuesPanel from './ReviewIssuesPanel.jsx';
import ObjectInspectorPanel from './ObjectInspectorPanel.jsx';
import SheetFrameProposalsPanel from './SheetFrameProposalsPanel.jsx';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`;

const BackBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: #e97024;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;

  &:hover {
    background: rgba(233, 112, 36, 0.08);
  }
`;

const DetailTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #444;
`;

const Body = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Each sub-panel manages its own scroll — we just need to allow them to grow. */
`;

export default function ReviewRightPanel({
  tab,
  onTabChange,
  selectedComponent,
  activeSheetId,
  projectId,
  requirementId,
  firmId,
  hatId,
  onHatChange,
  selectedIssueId,
  onSelectIssue,
  onNavigateToCompliance,
  onSelectMappingComponent,
  onSheetsLoaded,
  onOpenMappingFromDetail,
  onInspectorSaved,
  onLocalOverride,
  onCrossRefNavigate,
  sheetMeta,
  sheetIr,
  entityPages,
  scaleOverride = null,
  // Sheet frame review is per-PAGE, unlike every other tab here, which is
  // per-sheet or per-component. `null` means "no page resolved yet" and the
  // panel renders an explicit empty state rather than assuming page 0.
  sheetFramePageIndex = null,
  onSheetFrameSelectionChange,
}) {
  return (
    <Root>
      {tab === 'detail' && (
        <DetailHeader>
          <BackBtn type="button" onClick={() => onTabChange('mapping')}>
            <FiArrowLeft size={16} />
            Back
          </BackBtn>
          <DetailTitle>Object inspector</DetailTitle>
        </DetailHeader>
      )}
      <Body>
        {tab === 'mapping' && (
          <MappingCheckPanel
            projectId={projectId}
            requirementId={requirementId}
            firmId={firmId}
            hatId={hatId}
            onHatChange={onHatChange}
            onSelectComponent={onSelectMappingComponent}
            onSheetsLoaded={onSheetsLoaded}
          />
        )}
        {tab === 'sheetFrame' && (
          <SheetFrameProposalsPanel
            projectId={projectId}
            requirementId={requirementId}
            sheetId={activeSheetId}
            pageIndex={sheetFramePageIndex}
            onSelectionChange={onSheetFrameSelectionChange}
          />
        )}
        {tab === 'issues' && (
          <ReviewIssuesPanel
            projectId={projectId}
            requirementId={requirementId}
            selectedIssueId={selectedIssueId}
            onSelectIssue={onSelectIssue}
            onNavigateToCompliance={onNavigateToCompliance}
          />
        )}
        {tab === 'detail' && (
          <ObjectInspectorPanel
            component={selectedComponent}
            sheetId={activeSheetId}
            sheetMeta={sheetMeta}
            projectId={projectId}
            requirementId={requirementId}
            firmId={firmId}
            hatId={hatId}
            onSaved={onInspectorSaved}
            onLocalOverride={onLocalOverride}
            onCrossRefNavigate={onCrossRefNavigate}
            onSelectIssue={onSelectIssue}
            sheetIr={sheetIr}
            entityPages={entityPages}
            scaleOverride={scaleOverride}
          />
        )}
      </Body>
    </Root>
  );
}
